import { Price } from './restaurant.model';
import { DailyAvailability } from '../dto/catalog.dto';

export class MenuDiscountScheduleDay {
  constructor(
    public dayType: string = null,
    public startTime: string = null,
    public endTime: string = null,
  ) {}
}

export class MenuDiscount {
  constructor(
    public readonly id: string = null,
    public name: string = null,
    public discountType: string = null,
    public percentage: number = null,
    public amountMoney: Price = null,
    public quantity: number = null,
    public buyOneGetOne: boolean = false,
    public applyQuantity: number = null,
    public validFrom: string = null,
    public validUntil: string = null,
    public schedule: MenuDiscountScheduleDay[] = [],
  ) {}
}

export class Category {
  constructor(
    public readonly id: string = null,
    public name: string = null,
    public image_url: string = '../../../../../assets/images/no-image.svg',
    public items: Item[] = [],
    public subcategories: Category[] = [],
    public isCollapse: boolean = false,
    public hideItems: boolean = false,
    public showSubCategories: boolean = false,
    public parentCategoryId: string = null,
    public discount: MenuDiscount = null,
  ) {
  }
}

export class Item {
  constructor(
    public readonly id: string = null,
    public readonly category_id: string = null,
    public name: string = '',
    public description: string = null,
    public image_url: string = null,
    public variations: Variation[] = [],
    public locationId: string = null,
    public selected_quantity: number = 0,
    public isEnabled: boolean = true,
    public discount: MenuDiscount = null,
  ) {
  }
}
export class Variation {
  constructor(
    public readonly id: string = null,
    public readonly category_id: string = null,
    public name: string = null,
    public price_money: Price = new Price(),
    public opening_lead_time: string = '',
    public closing_lead_time: string = '',
    public pickup_lead_time: string = '',
    public allow_custom_note: boolean = false,
    public daily_availability: DailyAvailability[] = null,
    public daily_availability_enabled: boolean = false,
    public fulfillments: string[] = [],
    public available_from: Date = new Date(),
    public available_until: Date = new Date(),
    public fulfillment_restriction_enabled: boolean = false,
    public track_inventory: boolean = false,
    public sold_out: boolean = false,
    public modifier_lists: ModifierList[] = [],
    public nutrition_facts: NutritionFacts = new NutritionFacts(),
    public dietary_labels: DietaryLabels =  new DietaryLabels(),
    public contains_alcohol: boolean = false,
    public quantity_remaining: number = null,
    public throttling_estimation: string = null,
    public discount: MenuDiscount = null,
  ) {}
}


export class NutritionFacts {
  constructor(
    public added_sugars: number = 0,
    public calories: number = 0,
    public cholesterol: number = 0,
    public fiber: number = 0,
    public potassium: number = 0,
    public protein: number = 0,
    public saturated_fat: number = 0,
    public sodium: number = 0,
    public sugars: number = 0,
    public total_carbs: number = 0,
    public total_fat: number = 0,
    public trans_fat: number = 0
  ) {
  }
}
export class DietaryLabels {
  constructor(
    public dairy_free: boolean = false,
    public gluten_free: boolean = false,
    public halal: boolean = false,
    public vegan: boolean = false,
    public vegetarian: boolean = false
  ) {
  }
}

export class ModifierList {
  constructor(
    public readonly id: string = null,
    public allow_quantities: boolean = false,
    public max_selected_modifiers: number = null,
    public min_selected_modifiers: number = null,
    public name: string = null,
    public modifiers: Modifier[] = [],
  ) {
  }
}

export class Modifier {
  constructor(
    public readonly id: string = null,
    public name: string = null,
    public price_money: Price = new Price(),
    public hidden_online: boolean = false,
    public on_by_default: boolean = false,
    public sold_out: boolean = false,
    public selected: boolean = false,
    public quantity: number = 0,
  ) {
  }
}

// @ts-ignore
export class VariationInventoryInfo {
  constructor(
    public calculated_at: Date,
    public catalog_object_id: string,
    public catalog_object_type: string,
    public location_id: string,
    public quantity: string,
    public state: string
  ) {
  }
}
